import { useEffect } from "react";
import { tokenManager } from "../../Api/tokenManager";
import { enableHealbidWebPush, initHealbidWebFirebase } from "../../firebase/messaging";

/**
 * Boots Firebase Analytics + FCM on the website when a user session exists.
 * Token is stored in localStorage (`healbid_web_fcm_token`) for later server sends.
 */
export default function WebPushBootstrap() {
  useEffect(() => {
    let cancelled = false;

    (async () => {
      await initHealbidWebFirebase();
      if (cancelled) return;

      const hasSession =
        Boolean(tokenManager.getTokenForRole("patient")) ||
        Boolean(tokenManager.getTokenForRole("doctor")) ||
        Boolean(tokenManager.getTokenForRole("hospital"));

      if (!hasSession) return;
      await enableHealbidWebPush();
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  return null;
}
